// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ShipToOemModalComponent_modalBody__2gujD","modalFooter":"ShipToOemModalComponent_modalFooter__1-KCF","highlight":"ShipToOemModalComponent_highlight__2s8id"};